
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","viewBox":"0 0 13 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"User-Dashboard","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd","stroke-linecap":"square","stroke-opacity":".3"}},[_c('g',{attrs:{"id":"Wallet_BeneficialOwners_Mobile","transform":"translate(-338 -582)","stroke":"#9D9C9C"}},[_c('g',{attrs:{"id":"Beneficial-Owners","transform":"translate(10 302)"}},[_c('g',{attrs:{"id":"Forms","transform":"translate(0 265)"}},[_c('g',{attrs:{"id":"Owners-Form/Verified/Verification"}},[_c('g',{attrs:{"id":"Top-line"}},[_c('path',{attrs:{"d":"M11.5 4v15m7.5-7.5H4","transform":"rotate(-45 183.864 -373.895)","id":"Combined-Shape"}})])])])])])])])
          )
        }
      }
    